/**
 * Archivist Prompts (Content Excellence System)
 *
 * Prompts for categorizing and indexing expressions.
 *
 * @module config/prompts/archivist-prompts
 */
// ═══════════════════════════════════════════════════════════════════════════
// ARCHIVIST PROMPTS
// ═══════════════════════════════════════════════════════════════════════════
export const ARCHIVIST_CATEGORIZE_EXPRESSION = {
    id: 'ARCHIVIST_CATEGORIZE_EXPRESSION',
    name: 'Archivist Expression Categorization',
    description: 'Categorize an expression for indexing',
    template: `You are categorizing an expression for a semantic index.

The expression should be placed in the most specific applicable category.
Categories are hierarchical (e.g., "emotions/joy/gratitude").

{{#if existingCategories}}
Existing categories to consider:
{{#each existingCategories}}
- {{this.id}}: {{this.description}}
{{/each}}
{{/if}}

Expression:
{{expression}}

Respond with JSON:
{
  "categoryId": "suggested category ID (use / for hierarchy)",
  "categoryName": "Human-readable name",
  "categoryDescription": "What expressions in this category cover",
  "confidence": 0.0-1.0,
  "reasoning": "Brief explanation"
}`,
    requirements: {
        capabilities: ['json-mode'],
        temperature: 0.3,
        maxTokens: 512,
    },
    version: 1,
    usedBy: ['archivist'],
};
export const ARCHIVIST_FIND_CANONICAL = {
    id: 'ARCHIVIST_FIND_CANONICAL',
    name: 'Archivist Canonical Expression Finding',
    description: 'Find the best expression for a concept from candidates',
    template: `You are selecting the canonical (best) expression for a concept from candidates.

The concept/idea to express:
{{concept}}

Candidate expressions (with excellence scores):
{{#each candidates}}
{{@index}}. [Score: {{this.score}}] "{{this.text}}"
{{/each}}

Select the BEST expression based on:
1. Clarity of expression
2. Memorability
3. Conciseness
4. Authenticity of voice

Respond with JSON:
{
  "selectedIndex": number,
  "reasoning": "Why this is the best expression",
  "alternativeIndices": [other good options],
  "confidence": 0.0-1.0
}`,
    requirements: {
        capabilities: ['json-mode'],
        temperature: 0.3,
        maxTokens: 512,
    },
    version: 1,
    usedBy: ['archivist'],
};
export const ARCHIVIST_PROMPTS = [
    ARCHIVIST_CATEGORIZE_EXPRESSION,
    ARCHIVIST_FIND_CANONICAL,
];
//# sourceMappingURL=archivist-prompts.js.map